import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, remove, post } from '../models/base';

export const fetchAlbums = createAsyncThunk(
  'albums/fetchAlbums',
  async (selection, { rejectWithValue, getState }) => {
    const { pageNumber, perPage } = getState().albums;

    let path = `/api/albums?page=${pageNumber}&per_page=${perPage}`;

    if (selection) {
      path = `/api/albums?page=${pageNumber}&per_page=${perPage}&selection=true`;
    }

    try {
      const response = await get(path);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const deleteAlbum = createAsyncThunk(
  'albums/deleteAlbum',
  async (albumId, { rejectWithValue }) => {
    try {
      const queryPath = `/albums/${albumId}`;
      await remove(queryPath);
      return albumId;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const createAlbum = createAsyncThunk(
  'albums/createAlbum',
  async (selection, { rejectWithValue, getState }) => {
    const { albumName } = getState().albums;
    const data = {
      name: albumName,
      selection,
    };

    try {
      const queryPath = '/albums';
      const response = await post(queryPath, data);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
